/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxDeclarationResponse } from '../../models/tax-declaration-response';

export interface ApiTaxDeclarationLastGet$Plain$Params {
}

export function apiTaxDeclarationLastGet$Plain(http: HttpClient, rootUrl: string, params?: ApiTaxDeclarationLastGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxDeclarationResponse>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationLastGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxDeclarationResponse>;
    })
  );
}

apiTaxDeclarationLastGet$Plain.PATH = '/api/TaxDeclaration/last';
